import { PlusOutlined } from "@ant-design/icons";
import { Button, Empty } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { CollapseButton } from "../../../../../../components/CollapseButton";
import { MdmCardFormStore } from "../../MdmCardFormStore";
import { FormCollapseList } from "../../types/MdmCardFormTypes";
import * as styles from "./CollapseList.module.less";

interface PropsCollapseList {
  field: FormCollapseList;
  form: MdmCardFormStore;
}

export const CollapseList: React.FC<PropsCollapseList> = observer((props) => {
  const { field, form } = props;
  const { rows } = field;
  const disabled = form.isItemDisabled(field);
  return (
    <div className={classNames([styles.box])}>
      <div className={styles.title}>
        <CollapseButton
          collapsed={field.collapsed}
          onChange={(v) => field.setCollapsed(v)}
        />
        <span>{field.meta.title}</span>
        <div className={styles.rightTitle}>
          <span>{rows.length}</span>
          <Button
            size="small"
            type="primary"
            icon={<PlusOutlined />}
            disabled={disabled}
            onClick={() => field.newRow()}
          />
        </div>
      </div>
      {!field.collapsed && (
        <>
          {rows.length === 0 && (
            <div className={styles.empty}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
          {rows.length > 0 &&
            rows.map((row, i) => (
              <React.Fragment key={row.item.key}>
                <div className={styles.rowTitle}>
                  {i + 1}: {row.basePath}
                </div>
                {row.item.render(form)}
              </React.Fragment>
            ))}
        </>
      )}
    </div>
  );
});
